module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/png@2x/ist_PC_blankpage_Sharelink@2x-17a0fb.png";